module.exports = __webpack_public_path__ + "images/file_icons_v2/mp4-ffb842ac75abcb9d94da8bbca01ecc31.svg";